export const mapFormToInvoiceSupplierAPI = (data) => {
  // Helper to remove empty fields recursively
  const removeEmpty = (obj) => {
    if (typeof obj !== "object" || obj === null) return obj;

    return Object.entries(obj).reduce((acc, [key, value]) => {
      if (
        value !== "" &&
        value !== null &&
        value !== undefined &&
        (typeof value !== "object" || Object.keys(removeEmpty(value)).length > 0)
      ) {
        acc[key] = removeEmpty(value);
      }
      return acc;
    }, {});
  };

  const formatted = {
    invoiceSupplier: {
      Supplier: {
        Name: data.supplierName,
        Address: data.supplierAddress,
        Country: data.supplierCountry,
        City: data.supplierCity,
      },
      Seller: {
        Name: data.sellerName,
        Address: data.sellerAddress,
        Country: data.sellerCountry,
        City: data.sellerCity,
      },
      thirdParty: {
        Name: data.thirdPartyName,
        Address: data.thirdPartyAddress,
        Country: data.thirdPartyCountry,
        City: data.thirdPartyCity,
        State: data.thirdPartyState,
      },
      broker: {
        Name: data.brokerName,
        Address: data.brokerAddress,
        Country: data.brokerCountry,
        City: data.brokerCity,
      },
    },
  };

  return removeEmpty(formatted);
};

export const mapInvoiceSupplier = (data) => {
  const mapped = {};
  
  // Map supplier
  if (data.supplier) {
    mapped.supplierName =  data.supplier.name || '';
    mapped.supplierAddress = data.supplier.address || '';
    mapped.supplierCity = data.supplier.city || '';
    mapped.supplierCountry = data.supplier.country || '';
    // Don't include IDs if you don't want them
  }
  
  // Map seller
  if (data.seller) {
    mapped.sellerName = data.seller.name || '';
    mapped.sellerAddress = data.seller.address || '';
    mapped.sellerCity = data.seller.city || '';
    mapped.sellerCountry = data.seller.country || '';
  }
  
  // Map broker
  if (data.broker) {
    mapped.brokerName = data.broker.name || '';
    mapped.brokerAddress = data.broker.address || '';
    mapped.brokerCity = data.broker.city || '';
    mapped.brokerCountry = data.broker.country || '';
  }
  
  // Map thirdParty
  if (data.thirdParty) {
    mapped.thirdPartyName = data.thirdParty.name || '';
    mapped.thirdPartyAddress = data.thirdParty.address || '';
    mapped.thirdPartyCity = data.thirdParty.city || '';
    mapped.thirdPartyCountry = data.thirdParty.country || '';
    mapped.thirdPartyPinCode = data.thirdParty.pinCode || '';
    mapped.thirdPartyState = data.thirdParty.state || '';
  }
  
  return mapped;
};